"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Orange = exports.Red = exports.Purple = exports.Teal = exports.Aqua = exports.DarkBlue = exports.Yellow = exports.LightGreen = exports.Green = exports.DarkGreen = exports.NTWarmGrey = exports.NTGold = exports.NTGreen = exports.NTDarkGrey = void 0;
var NTDarkGrey;
(function (NTDarkGrey) {
    NTDarkGrey[NTDarkGrey["#F9F9F9"] = 0] = "#F9F9F9";
    NTDarkGrey[NTDarkGrey["#F6F6F6"] = 50] = "#F6F6F6";
    NTDarkGrey[NTDarkGrey["#EAEAEA"] = 100] = "#EAEAEA";
    NTDarkGrey[NTDarkGrey["#CECECE"] = 200] = "#CECECE";
    NTDarkGrey[NTDarkGrey["#B1B1B1"] = 300] = "#B1B1B1";
    NTDarkGrey[NTDarkGrey["#959595"] = 400] = "#959595";
    NTDarkGrey[NTDarkGrey["#808182"] = 500] = "#808182";
    NTDarkGrey[NTDarkGrey["#6B6E6F"] = 600] = "#6B6E6F";
    NTDarkGrey[NTDarkGrey["#565A5C"] = 700] = "#565A5C";
    NTDarkGrey[NTDarkGrey["#4A4D4F"] = 800] = "#4A4D4F";
    NTDarkGrey[NTDarkGrey["#3D4042"] = 900] = "#3D4042";
    NTDarkGrey[NTDarkGrey["#252627"] = 976] = "#252627";
})(NTDarkGrey = exports.NTDarkGrey || (exports.NTDarkGrey = {}));
var NTGreen;
(function (NTGreen) {
    NTGreen[NTGreen["#DFE8E5"] = 100] = "#DFE8E5";
    NTGreen[NTGreen["#BDD0C9"] = 200] = "#BDD0C9";
    NTGreen[NTGreen["#9AB8AE"] = 300] = "#9AB8AE";
    NTGreen[NTGreen["#78A093"] = 400] = "#78A093";
    NTGreen[NTGreen["#568777"] = 500] = "#568777";
    NTGreen[NTGreen["#336F5C"] = 600] = "#336F5C";
    NTGreen[NTGreen["#115740"] = 700] = "#115740";
    NTGreen[NTGreen["#0D4936"] = 800] = "#0D4936";
    NTGreen[NTGreen["#093B2B"] = 900] = "#093B2B";
})(NTGreen = exports.NTGreen || (exports.NTGreen = {}));
var NTGold;
(function (NTGold) {
    NTGold[NTGold["#F2EBD7"] = 100] = "#F2EBD7";
    NTGold[NTGold["#E1D4AE"] = 200] = "#E1D4AE";
    NTGold[NTGold["#D0BE85"] = 300] = "#D0BE85";
    NTGold[NTGold["#BFA85B"] = 400] = "#BFA85B";
    NTGold[NTGold["#AE9132"] = 500] = "#AE9132";
    NTGold[NTGold["#A8872A"] = 600] = "#A8872A";
    NTGold[NTGold["#A27D23"] = 700] = "#A27D23";
    NTGold[NTGold["#9C731C"] = 800] = "#9C731C";
    NTGold[NTGold["#966914"] = 900] = "#966914";
})(NTGold = exports.NTGold || (exports.NTGold = {}));
var NTWarmGrey;
(function (NTWarmGrey) {
    NTWarmGrey[NTWarmGrey["#F7F6F3"] = 100] = "#F7F6F3";
    NTWarmGrey[NTWarmGrey["#EFEDE7"] = 200] = "#EFEDE7";
    NTWarmGrey[NTWarmGrey["#E7E4DC"] = 300] = "#E7E4DC";
    NTWarmGrey[NTWarmGrey["#DEDBD0"] = 400] = "#DEDBD0";
    NTWarmGrey[NTWarmGrey["#D6D2C4"] = 500] = "#D6D2C4";
    NTWarmGrey[NTWarmGrey["#CBC6B3"] = 600] = "#CBC6B3";
    NTWarmGrey[NTWarmGrey["#C0B9A2"] = 700] = "#C0B9A2";
    NTWarmGrey[NTWarmGrey["#B5AD91"] = 800] = "#B5AD91";
    NTWarmGrey[NTWarmGrey["#AAA080"] = 900] = "#AAA080";
})(NTWarmGrey = exports.NTWarmGrey || (exports.NTWarmGrey = {}));
var DarkGreen;
(function (DarkGreen) {
    DarkGreen[DarkGreen["#E2FCE3"] = 100] = "#E2FCE3";
    DarkGreen[DarkGreen["#B8E1BA"] = 200] = "#B8E1BA";
    DarkGreen[DarkGreen["#8EC791"] = 300] = "#8EC791";
    DarkGreen[DarkGreen["#64AC68"] = 400] = "#64AC68";
    DarkGreen[DarkGreen["#3A913F"] = 500] = "#3A913F";
    DarkGreen[DarkGreen["#2D8031"] = 600] = "#2D8031";
    DarkGreen[DarkGreen["#206F23"] = 700] = "#206F23";
    DarkGreen[DarkGreen["#125D15"] = 800] = "#125D15";
    DarkGreen[DarkGreen["#054C07"] = 900] = "#054C07";
})(DarkGreen = exports.DarkGreen || (exports.DarkGreen = {}));
var Green;
(function (Green) {
    Green[Green["#E6F7C4"] = 100] = "#E6F7C4";
    Green[Green["#C6E396"] = 200] = "#C6E396";
    Green[Green["#A5CF68"] = 300] = "#A5CF68";
    Green[Green["#85BB39"] = 400] = "#85BB39";
    Green[Green["#64A70B"] = 500] = "#64A70B";
    Green[Green["#5D970C"] = 600] = "#5D970C";
    Green[Green["#56870E"] = 700] = "#56870E";
    Green[Green["#4F760F"] = 800] = "#4F760F";
    Green[Green["#486610"] = 900] = "#486610";
})(Green = exports.Green || (exports.Green = {}));
var LightGreen;
(function (LightGreen) {
    LightGreen[LightGreen["#FCFCC5"] = 100] = "#FCFCC5";
    LightGreen[LightGreen["#EAEC94"] = 200] = "#EAEC94";
    LightGreen[LightGreen["#D9DD63"] = 300] = "#D9DD63";
    LightGreen[LightGreen["#C7CD31"] = 400] = "#C7CD31";
    LightGreen[LightGreen["#B5BD00"] = 500] = "#B5BD00";
    LightGreen[LightGreen["#A4AA03"] = 600] = "#A4AA03";
    LightGreen[LightGreen["#949807"] = 700] = "#949807";
    LightGreen[LightGreen["#83850A"] = 800] = "#83850A";
    LightGreen[LightGreen["#72720D"] = 900] = "#72720D";
})(LightGreen = exports.LightGreen || (exports.LightGreen = {}));
var Yellow;
(function (Yellow) {
    Yellow[Yellow["#FFF4C0"] = 100] = "#FFF4C0";
    Yellow[Yellow["#FFDF84"] = 200] = "#FFDF84";
    Yellow[Yellow["#FCD76E"] = 300] = "#FCD76E";
    Yellow[Yellow["#FDCF4B"] = 400] = "#FDCF4B";
    Yellow[Yellow["#FABE0F"] = 500] = "#FABE0F";
    Yellow[Yellow["#E5AD08"] = 600] = "#E5AD08";
    Yellow[Yellow["#D09D07"] = 700] = "#D09D07";
    Yellow[Yellow["#B98A00"] = 800] = "#B98A00";
    Yellow[Yellow["#A0761C"] = 900] = "#A0761C";
})(Yellow = exports.Yellow || (exports.Yellow = {}));
var DarkBlue;
(function (DarkBlue) {
    DarkBlue[DarkBlue["#CBEAFA"] = 100] = "#CBEAFA";
    DarkBlue[DarkBlue["#86D2F9"] = 200] = "#86D2F9";
    DarkBlue[DarkBlue["#4AB0E5"] = 300] = "#4AB0E5";
    DarkBlue[DarkBlue["#2E8FC2"] = 400] = "#2E8FC2";
    DarkBlue[DarkBlue["#0A699B"] = 500] = "#0A699B";
    DarkBlue[DarkBlue["#165F86"] = 600] = "#165F86";
    DarkBlue[DarkBlue["#1C5472"] = 700] = "#1C5472";
    DarkBlue[DarkBlue["#104866"] = 800] = "#104866";
    DarkBlue[DarkBlue["#063D5B"] = 900] = "#063D5B";
})(DarkBlue = exports.DarkBlue || (exports.DarkBlue = {}));
var Aqua;
(function (Aqua) {
    Aqua[Aqua["#E1FCFF"] = 100] = "#E1FCFF";
    Aqua[Aqua["#A2EAF4"] = 200] = "#A2EAF4";
    Aqua[Aqua["#68D2D8"] = 300] = "#68D2D8";
    Aqua[Aqua["#36B4BC"] = 400] = "#36B4BC";
    Aqua[Aqua["#00A0AA"] = 500] = "#00A0AA";
    Aqua[Aqua["#088B94"] = 600] = "#088B94";
    Aqua[Aqua["#0A7A82"] = 700] = "#0A7A82";
    Aqua[Aqua["#05676E"] = 800] = "#05676E";
    Aqua[Aqua["#085459"] = 900] = "#085459";
})(Aqua = exports.Aqua || (exports.Aqua = {}));
var Teal;
(function (Teal) {
    Teal[Teal["#E9FFF9"] = 100] = "#E9FFF9";
    Teal[Teal["#D0F4EB"] = 200] = "#D0F4EB";
    Teal[Teal["#B5E3D8"] = 300] = "#B5E3D8";
    Teal[Teal["#8AD2C6"] = 400] = "#8AD2C6";
    Teal[Teal["#64C8AF"] = 500] = "#64C8AF";
    Teal[Teal["#49B69B"] = 600] = "#49B69B";
    Teal[Teal["#37A085"] = 700] = "#37A085";
    Teal[Teal["#1F8A6F"] = 800] = "#1F8A6F";
    Teal[Teal["#12745B"] = 900] = "#12745B";
})(Teal = exports.Teal || (exports.Teal = {}));
var Purple;
(function (Purple) {
    Purple[Purple["#FFEEFD"] = 100] = "#FFEEFD";
    Purple[Purple["#E3C1DE"] = 200] = "#E3C1DE";
    Purple[Purple["#C489BB"] = 300] = "#C489BB";
    Purple[Purple["#AC5D9F"] = 400] = "#AC5D9F";
    Purple[Purple["#8E3A80"] = 500] = "#8E3A80";
    Purple[Purple["#813275"] = 600] = "#813275";
    Purple[Purple["#752A6A"] = 700] = "#752A6A";
    Purple[Purple["#68215E"] = 800] = "#68215E";
    Purple[Purple["#5B1953"] = 900] = "#5B1953";
})(Purple = exports.Purple || (exports.Purple = {}));
var Red;
(function (Red) {
    Red[Red["#FFE8E6"] = 100] = "#FFE8E6";
    Red[Red["#F7C2BB"] = 200] = "#F7C2BB";
    Red[Red["#F57D69"] = 300] = "#F57D69";
    Red[Red["#F5634D"] = 400] = "#F5634D";
    Red[Red["#E04E39"] = 500] = "#E04E39";
    Red[Red["#D04532"] = 600] = "#D04532";
    Red[Red["#BF3B2A"] = 700] = "#BF3B2A";
    Red[Red["#AA2D28"] = 800] = "#AA2D28";
    Red[Red["#941A0D"] = 900] = "#941A0D";
})(Red = exports.Red || (exports.Red = {}));
var Orange;
(function (Orange) {
    Orange[Orange["#FFEEDE"] = 100] = "#FFEEDE";
    Orange[Orange["#F9CFA7"] = 200] = "#F9CFA7";
    Orange[Orange["#FBA755"] = 300] = "#FBA755";
    Orange[Orange["#FA9619"] = 400] = "#FA9619";
    Orange[Orange["#E97C05"] = 500] = "#E97C05";
    Orange[Orange["#D77200"] = 600] = "#D77200";
    Orange[Orange["#BF5E00"] = 700] = "#BF5E00";
    Orange[Orange["#AC5300"] = 800] = "#AC5300";
    Orange[Orange["#994900"] = 900] = "#994900";
})(Orange = exports.Orange || (exports.Orange = {}));
